/* ============================================================
   Doran Reviews — Rating text reformatter
   Changes "X.0/5" → "X.0/5.0" everywhere on the page
   Targets all DOM elements, including Doran widget containers
   ============================================================ */
(function () {
    'use strict';

    var PATTERN = /(\d(?:\.\d)?)\s*\/\s*5(?!\.)/g;

    function normalizeRating(match, num) {
        if (num.indexOf('.') === -1) num = num + '.0';
        return num + '/5.0';
    }

    function fixElement(el) {
        /* Fix text nodes */
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
        var node;
        while ((node = walker.nextNode())) {
            var txt = node.textContent;
            PATTERN.lastIndex = 0;
            if (PATTERN.test(txt)) {
                PATTERN.lastIndex = 0;
                node.textContent = txt.replace(PATTERN, normalizeRating);
            }
        }

        /* Also directly check innerHTML of all elements for embedded text */
        var allEls = el.querySelectorAll('*');
        for (var i = 0; i < allEls.length; i++) {
            var child = allEls[i];
            /* Skip elements that have child elements (only target leaf elements) */
            if (child.children && child.children.length === 0) {
                var html = child.innerHTML;
                PATTERN.lastIndex = 0;
                if (PATTERN.test(html)) {
                    PATTERN.lastIndex = 0;
                    child.innerHTML = html.replace(PATTERN, normalizeRating);
                }
            }
            /* Also check shadow roots */
            if (child.shadowRoot) {
                fixElement(child.shadowRoot);
            }
        }
    }

    function runFix() {
        try {
            if (document.body) fixElement(document.body);

            /* Check iframes */
            var iframes = document.querySelectorAll('iframe');
            for (var i = 0; i < iframes.length; i++) {
                try {
                    var doc = iframes[i].contentDocument || (iframes[i].contentWindow && iframes[i].contentWindow.document);
                    if (doc && doc.body) fixElement(doc.body);
                } catch (e) { /* cross-origin */ }
            }
        } catch (e) {
            /* silently fail */
        }
    }

    /* Schedule at many intervals to catch async widget loads */
    function schedule() {
        var delays = [300, 600, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 6000, 8000, 10000, 15000];
        for (var i = 0; i < delays.length; i++) {
            setTimeout(runFix, delays[i]);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', schedule);
        window.addEventListener('load', function () {
            setTimeout(runFix, 500);
            setTimeout(runFix, 2000);
        });
    } else {
        schedule();
    }

    /* MutationObserver for dynamic content */
    var timer;
    function debouncedFix() {
        clearTimeout(timer);
        timer = setTimeout(runFix, 400);
    }

    function startObserver() {
        if (!document.body) return;
        var obs = new MutationObserver(debouncedFix);
        obs.observe(document.body, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }

    if (document.body) {
        startObserver();
    } else {
        document.addEventListener('DOMContentLoaded', startObserver);
    }
})();
